import React, { useCallback, useEffect } from "react";
import FemsAPP from "../fems/FemsAPP";
import { FxmsData } from "../fxms/datas/FxData";
import { FxFormSample } from "../fxms/inputs/FxForm";
import { VupData } from "./datas/VupData";

const TestApp = (props) => {
  const [init, setInit] = React.useState(false);

  useEffect(() => {


    // 로그인한 사용자의 설치위치 정보를 확인하여
    // 총괄, 산단, 공단 대시보드로 이동한다.

    const user = FxmsData.getUser();
    const inlo = FxmsData.getInlo(user.inloNo);

    VupData.initData(function (obj) {
      setInit(true);
    });

  }, []);


  return (

    <>
      <FemsAPP />
      <FxFormSample isLoaded={init}/>

    </>
  );
};

export default TestApp;
